import React, { useState } from "react";
import { intl } from "LocaleWrapper";
import { CreateBlock, Height } from "../Blocks";
import SalesCharterCreateEditDialog from "./SalesCharterCreateEditDialog";

const SalesCharterCreateBlock = ({ onAdd }: { onAdd: (charterId: number) => void; }) => {

	const [ dialogOpen, openDialog ] = useState(false);

	return (
		<React.Fragment>
			<CreateBlock
				height={Height.Medium}
				onClick={() => openDialog(true)}
				title={intl.formatMessage({ id: "CREATE_CHARTER" })} />

			<SalesCharterCreateEditDialog
				open={dialogOpen}
				onClose={() => openDialog(false)}
				refetch={(charterId) => onAdd(charterId)} />
		</React.Fragment>
	);
};

export default SalesCharterCreateBlock;
